module.exports = __webpack_public_path__ + "img/4_70.f95c3674.png";